import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {
  DragSource,
  DropTarget,
} from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { connect } from 'react-redux';
import { ChromePicker } from 'react-color';
import {
  Card,
  CardBody,
  Collapse,
  Row,
  Col,
  Label,
  Input,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import AdminPageSectionHeader from './SectionHeader';

import ItemTypes from '../../../helpers/DNDItemTypes';
import {
  pageSectionsTarget,
  pageSectionsSource,
} from '../../../helpers/DNDPageSections';

class AdminPageSectionDivider extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      colorPickerOpened: false,
    };

    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    const { connectDragPreview } = this.props;

    if (connectDragPreview) {
      connectDragPreview(getEmptyImage(), {
        captureDraggingState: true,
      });
    }
  }

  handleChange(e) {
    const {
      section,
      handleChangeSection,
    } = this.props;
    const {
      name,
      value,
      type,
      checked,
    } = e.target;

    if (type === 'checkbox') {
      section[name] = checked;
    } else {
      section[name] = value;
    }
    handleChangeSection(section);
  }

  render() {
    const { colorPickerOpened } = this.state;
    const {
      intl,
      id,
      section,
      sectionIndex,
      sectionsCount,
      isClosed,
      isDragging,
      handleDeleteSection,
      handleSwitchSection,
      handleMoveSectionByIndex,
      handleSetDraggableState,
      connectDragSource,
      connectDropTarget,
    } = this.props;

    return (
      connectDragSource(connectDropTarget((
        <div id={`s-${id}`} className={classnames('section-container', `section-${section.section}`, { dragging: isDragging })}>
          <Card>
            <AdminPageSectionHeader
              section={section}
              sectionIndex={sectionIndex}
              sectionsCount={sectionsCount}
              isClosed={isClosed}
              handleDeleteSection={handleDeleteSection}
              handleSwitchSection={handleSwitchSection}
              handleMoveSection={handleMoveSectionByIndex}
            />
            <Collapse isOpen={!isClosed}>
              <CardBody>
                <Row form>
                  <Col xs="6">
                    <Label htmlFor={`section-style-${section.id}`}>
                      {intl.formatMessage({ defaultMessage: 'Style' })}
                    </Label>
                    <Input
                      type="select"
                      className="custom-select"
                      id={`section-style-${section.id}`}
                      name="style"
                      defaultValue={section.style || 'line'}
                      onChange={this.handleChange}
                    >
                      <option value="solid">{intl.formatMessage({ defaultMessage: 'Line' })}</option>
                      <option value="double">{intl.formatMessage({ defaultMessage: 'Double line' })}</option>
                      <option value="dotted">{intl.formatMessage({ defaultMessage: 'Dotted' })}</option>
                      <option value="dashed">{intl.formatMessage({ defaultMessage: 'Dashed' })}</option>
                    </Input>
                  </Col>
                  <Col xs="3">
                    <Label htmlFor={`section-size-${section.id}`}>
                      {intl.formatMessage({ defaultMessage: 'Size (px)' })}
                    </Label>
                    <Input
                      type="number"
                      id={`section-size-${section.id}`}
                      name="size"
                      min="1"
                      max="10"
                      defaultValue={section.size || 1}
                      onChange={this.handleChange}
                    />
                  </Col>
                  <Col xs="3">
                    <Label htmlFor={`section-color-${section.id}`}>
                      {intl.formatMessage({ defaultMessage: 'Color' })}
                    </Label>
                    <div className="color-button-container">
                      <div
                        className="color-button"
                        onClick={() => {
                          this.setState({ colorPickerOpened: true });
                          handleSetDraggableState(false);
                        }}
                        aria-hidden="true"
                      >
                        <div className="color-button-content" style={{ backgroundColor: section.color }} />
                      </div>
                      {colorPickerOpened && (
                        <div className="color-picker-popover">
                          <div
                            className="color-picker-cover"
                            onClick={() => {
                              this.setState({ colorPickerOpened: false });
                              handleSetDraggableState(true);
                            }}
                            aria-hidden="true"
                          />
                          <ChromePicker
                            color={section.color}
                            disableAlpha={true}
                            onChange={(c) => {
                              this.handleChange({
                                target: {
                                  name: 'color',
                                  value: c.hex,
                                },
                              });
                            }}
                          />
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Collapse>
          </Card>
        </div>
      )))
    );
  }
}

AdminPageSectionDivider.propTypes = {
  intl: PropTypes.object.isRequired,
  connectDragSource: PropTypes.func.isRequired,
  connectDropTarget: PropTypes.func.isRequired,
  connectDragPreview: PropTypes.func.isRequired,
  isDragging: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  section: PropTypes.object.isRequired,
  sectionIndex: PropTypes.number.isRequired,
  sectionsCount: PropTypes.number.isRequired,
  isClosed: PropTypes.bool.isRequired,
  handleChangeSection: PropTypes.func.isRequired,
  handleDeleteSection: PropTypes.func.isRequired,
  handleSwitchSection: PropTypes.func.isRequired,
  handleMoveSectionByIndex: PropTypes.func.isRequired,
  handleSetDraggableState: PropTypes.func.isRequired,
};

export default
DragSource(ItemTypes.PAGE_SECTION, pageSectionsSource, (DNDconnect, monitor) => ({
  connectDragSource: DNDconnect.dragSource(),
  connectDragPreview: DNDconnect.dragPreview(),
  isDragging: monitor.isDragging(),
}))(DropTarget(ItemTypes.PAGE_SECTION, pageSectionsTarget, DNDconnect => ({
  connectDropTarget: DNDconnect.dropTarget(),
}))(connect()(injectIntl(AdminPageSectionDivider))));
